'use client';

import { PageHeader } from '@ui/components/layouts';
import { GardenSelect, GardenOption } from '@/src/components/GardenSelect';

interface PageHeaderWithGardenSelectorProps {
  title: string;
  description?: string;
  gardens: GardenOption[];
  selectedGardenId: string | null;
  onGardenChange: (gardenId: string | null) => void;
  gardenSelectLabel?: string;
}

export function PageHeaderWithGardenSelector({
  title,
  description,
  gardens,
  selectedGardenId,
  onGardenChange,
  gardenSelectLabel = 'Selected Garden',
}: PageHeaderWithGardenSelectorProps) {
  return (
    <PageHeader
      title={title}
      description={description}
      actions={
        <GardenSelect
          gardens={gardens}
          selectedGardenId={selectedGardenId}
          onGardenChange={onGardenChange}
          label={gardenSelectLabel}
          showPlantCount={true}
          width={320}
        />
      }
    />
  );
}
